import React from "react";
import styles from "./dotProgress.scss";

export const DotProgress = () => (
  <div className={styles.dotLoading}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);


